import React , {useEffect} from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormContext } from '../../contexts/FormContext';
import "../../../stylesheets/detailsForm.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function ModifiedForm({ children, submitFunction , isReset }) {

    const { register, formState: { errors }, handleSubmit, control, setValue,reset } = useForm();
    const { t } = useTranslation();

    async function onSubmit(data) {
        console.log(`Form Data = ${JSON.stringify(data)}`)
        for(let key in data){
            if(data[key] == ""){
                delete data[key]
            }
        }
        const res = await submitFunction(data).catch(err=> console.log(err))
        if(res){
            setTimeout(() => {
            if (res.type === 2){
                console.log(res)
                for(let key in res.message){
                    toast.error(key + " : " + res.message[key][0]);
    
                }
            }
           
            else
                toast.info(res.message);
        }, 500);
        }
        console.log(isReset)
        if(isReset) reset()
        
    }
    
    return (
        <FormContext.Provider value={{ register, errors, control, setValue }}>
            <form className="modifiedForm" onSubmit={handleSubmit(onSubmit)}
            >
                {children}
                <ToastContainer position="bottom-right" />

            </form>
        </FormContext.Provider>
    )
}
